export function fmtDate(s: string | null | undefined): string {
  if (!s) return '—'
  return new Date(s).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' })
}

export function fmtRelative(s: string | null | undefined): string {
  if (!s) return '—'
  const delta = (Date.now() - new Date(s).getTime()) / 1000
  if (delta < 60) return 'только что'
  if (delta < 3600) return `${Math.floor(delta / 60)}м назад`
  if (delta < 86400) return `${Math.floor(delta / 3600)}ч назад`
  if (delta < 86400 * 30) return `${Math.floor(delta / 86400)}д назад`
  return fmtDate(s)
}

export function typeColor(type: string): 'blue' | 'amber' | 'purple' {
  if (type === 'domain') return 'blue'
  if (type === 'ip') return 'amber'
  return 'purple'
}

export function validateIpCidr(s: string): boolean {
  return /^(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?$/.test(s.trim())
}

export function validateDomain(s: string): boolean {
  return /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(s.trim())
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch { return false }
}
